export const aboutMeConfig = {
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  imgStart: true,
  img: require("../images/photo.jpeg") as string,
  dark: true,
  primary: false,
  darkText: true,
};
